import React from 'react';
import { Button } from '@fourthwall/components';
import * as S from './MailchimpGetStarted.styled';
export const MailchimpGetStarted = ({ refreshLists, isRefreshing }) => {
    const handleGetStarted = async () => {
        try {
            await refreshLists();
        }
        catch (error) {
            console.error('Failed to refresh Mailchimp lists:', error);
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, "Connect with Mailchimp"),
        React.createElement(S.Description, null, "Integrate your Fourthwall shop with Mailchimp to automatically sync customer data and create powerful email marketing campaigns."),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Get Started", appearance: "primary", loading: isRefreshing, disabled: isRefreshing, onClick: handleGetStarted }))));
};
